/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {ScDialogService as Éµa} from './lib/components/sc-dialogs';